import { render, staticRenderFns } from "./formDialog.vue?vue&type=template&id=2fba61a4&scoped=true"
import script from "./formDialog.vue?vue&type=script&lang=js"
export * from "./formDialog.vue?vue&type=script&lang=js"
import style0 from "./formDialog.vue?vue&type=style&index=0&id=2fba61a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba61a4",
  null
  
)

export default component.exports